import angular from 'angular';
import _ from 'lodash';
import {Module, Service} from 'app/decorators';


const STATUS = {
    CONNECTING: 'connecting',
    BUSY: 'controller_busy',
    CONNECTED: 'connected',
    NOT_CONNECTED_WITH_CTRL: 'no_connection_with_ctrl',
    NOT_CONNECTED_WITH_BB: 'no_connection_with_bb',

};

const ACTIONS = {
    RESET_REGISTERS: 'reset_registers'
};

@Module({
    name: 'app.services.bb',
})
@Service('BB')
export default class BB {
    constructor ($http, $q, Config) {
        "ngInject";
        this.$q = $q;
        this.$http = $http;
        this.baseUrl = Config.$config.config_params.BB_URL;
        this.ctrl = {
            state: STATUS.CONNECTING,
            action: '',
        }
    }

    dataEntry (tag, code, value) {
        let entry = {
            tag_type: tag.startsWith('D') ? 196: 195, // 196 is DINT and 195 is REAL
            elements: 1,
            method: 'read',
            path: [
                {
                    symbolic: tag,
                },
                {
                    element: code,
                },
            ],
        };

        if (value) {
            entry.data = _.isArray(value) ? value : [value];
            entry.elements = entry.data.length;
            entry.method = 'write';
        }
        return entry;
    }

    sendPresets (tags, data) {
        let self = this;
        data = data.map(function(l){
            return self.dataEntry(l.write_tag, l.preset_code, l.preset);
        });

        _.each(tags, function (key) {
            data.push(self.dataEntry(key, 0, 9999));
        });

        return self.status(tags).then(function () {
            if (self.ctrl.state !== STATUS.CONNECTED) { return self.$q.reject() }

            return self.resetRegisters(tags).then(function () {
                return self.$http.post(`${self.baseUrl}/api/controller/tags`, data).then(resp => resp.data);
            });
        });
    }

    status (tags) {
        let self = this;
        let data = _.map(tags, (tag) => {
            return self.dataEntry(tag, 0);
        });

        self.checking = true;
        return this.$http.post(`${self.baseUrl}/api/controller/tags`, data).then(
            (resp) => {
                self.ctrl.state =  (_.every(_.map(_.flatten(resp.data.result), o => o != 0))) ? STATUS.BUSY : STATUS.CONNECTED;
                return resp;
            },
            (resp) => {
                self.ctrl.state = (resp.status === 503) ? STATUS.NOT_CONNECTED_WITH_CTRL: STATUS.NOT_CONNECTED_WITH_BB;
                return resp;
            }
        ).finally(() => self.checking = false);
    }

    resetRegisters (tags) {
        let self = this;
        let zeroes = _.times(101, _.constant(0));
        let data = _.map(tags, function (tag) {
            return self.dataEntry(tag, 0, zeroes);
        });

        self.ctrl.action = ACTIONS.RESET_REGISTERS;
        return this.$http.post(`${self.baseUrl}/api/controller/tags`, data).then((resp) => {
            return resp.data
        }).finally(() => self.ctrl.action = '')
    }

}



// WEBPACK FOOTER //
// ./src/app/services/bb.js